<template>
    <v-row class='justify-center'>
        <v-col lg=3 md=12>
            <v-card min-height='300' class='pa-8'>
                <v-card-title>Login</v-card-title>
                <v-form class='pb-3' ref="form">
                    <v-text-field :rules="[rules.required]" outlined v-model="email" dense label='Email'></v-text-field>
                    <v-text-field outlined v-model="password" dense type='password' label='Password'></v-text-field>
                    <v-btn @click="userLogin" color='primary'>Login</v-btn>
                </v-form>

                <p class='text-center'>Not yet registered?</p>
                <a @click="signup"><p class='text-center'>Signup</p></a>

                <v-snackbar
                    v-model="snackbar"
                    :bottom="y === 'bottom'"
                    :color="color"
                    :left="x === 'left'"
                    :multi-line="mode === 'multi-line'"
                    :right="x === 'right'"
                    :timeout="timeout"
                    :top="y === 'top'"
                    :vertical="mode === 'vertical'"
                >
                {{ text }}
                    <template v-slot:action="{ attrs }">
                      <v-btn
                        dark
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                      >
                        Close
                      </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-col>

    </v-row>
  
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
            color: '',
            mode: '',
            snackbar: false,
            text: '',
            timeout: 6000,
            x: null,
            y: 'top',
        }
    },
    methods: ({
        signup(){
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/signup' })
        },
        userLogin(){
            if(this.$refs.form.validate())
            {
                var unique_id = window.localStorage.getItem('unique_id');
                var that = this;
                axios.request({
                    url: '/customer/login',
                    method: 'POST',
                    baseURL: myBaseURL,
                    data : {
                        'email' : that.email,
                        'password' : that.password,
                        'store_slug' : that.$route.params.store_slug,
                        'unique_id' : unique_id
                    }
                }).then(response => {
                    if(response.data.status)
                    {
                        console.log(response.data.access_token);
                        localStorage.setItem('access_token', response.data['access_token']);
                        this.$router.push(this.$route.query.redirect || ('/' + this.$route.params.store_slug))
                        // that.$router.push({ path: '/' + this.$route.params.store_slug });
                    }
                    else
                    {
                        that.text = response.data.message
                        that.snackbar = true;   
                    }
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
        }
    })
}
</script>